export class DynamoDbBackupConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "maxReadCapacityUnits",
            "baseName": "maxReadCapacityUnits",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxReadCapacityPercentage",
            "baseName": "maxReadCapacityPercentage",
            "type": "number",
            "format": ""
        },
        {
            "name": "isAutoscaleEnabled",
            "baseName": "isAutoscaleEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "incrementalExportEnabled",
            "baseName": "incrementalExportEnabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDbBackupConfig.attributeTypeMap;
    }
    constructor() {
    }
}
